
import React from 'react';
import BaseChart from './common/BaseChart';
import PieChartComponent from './common/PieChartComponent';
import ChartSkeleton from '../common/ChartSkeleton';

interface OptimizedPieChartProps {
  data: any[];
  loading: boolean;
  exportCSV: (data: any[], filename: string) => void;
  COLORS: string[];
  title: string;
  description: string;
  exportFilename: string;
  dataKey: string;
  nameKey: string;
  formatter?: (value: any) => any;
}

const OptimizedPieChart = React.memo(({ 
  data, 
  loading, 
  exportCSV, 
  COLORS,
  title,
  description,
  exportFilename,
  dataKey,
  nameKey,
  formatter
}: OptimizedPieChartProps) => {
  if (loading) {
    return (
      <ChartSkeleton 
        title={title}
        description={description}
        type="pie"
      />
    );
  }

  return (
    <BaseChart
      title={title}
      description={description}
      data={data}
      loading={false}
      exportCSV={exportCSV}
      exportFilename={exportFilename}
      chartType="pie"
    >
      <PieChartComponent
        data={data}
        dataKey={dataKey}
        nameKey={nameKey}
        colors={COLORS}
        formatter={formatter}
      />
    </BaseChart>
  );
});

OptimizedPieChart.displayName = 'OptimizedPieChart';

export default OptimizedPieChart;
